import { useTranslation } from 'react-i18next'
import { usePermissions } from '~/entities/viewer'
import { canShowObject } from '~/shared/lib/utils'

type Header = { label: string; to: string; parent?: string }

export const useHeader = (): Header[] => {
  const { t } = useTranslation()
  const { canDebtsView, canSettingsView } = usePermissions()

  return [
    ...canShowObject(canDebtsView, {
      label: t('debts'),
      to: '/debts',
    }),
    ...canShowObject(canSettingsView, {
      label: t('settings'),
      to: '/settings/employees',
      parent: '/settings',
    }),
  ]
}
